import { selectTypes } from "../../types/selects/types"
import { serverRequest } from "../../../utility/helpers/Axios/serverRequest"

export const addSelectOptions = (key, options) => ({
    type: selectTypes.addSelectOptions,
    payload: { key, options }
})

export const transformLabel = (labelName, option, splited) => {
    const tmpLabelName = [...labelName]
    const ref = tmpLabelName.shift()
    if (splited) {
        let rest = {}
        for (const label of tmpLabelName) {
            rest[label] = option[label]
        }
        return { label: option[ref], ...rest }
    } else {
        let label = tmpLabelName.map(ln => (option[ln])).join(" / ")
        if (labelName.length > 1) {
            label = `[${option[ref]}] - ${tmpLabelName.map(ln => (option[ln])).join(" / ")}`
        }
        return { label }

    }
}

export const startAddSelectOptions = (endPoint, key, labelName = 'name', params, splited = false) => {
    return async (dispatch) => {
        const data = await serverRequest(endPoint, null, params || [])
        if (data instanceof Array) dispatch(addSelectOptions(key, data.map(option => {
            if (labelName instanceof Array) return { ...transformLabel(labelName, option, splited), value: option.id }
            return { label: option[labelName], value: option.id }
        })))
        else {
            try {
                Object
                    .entries(data)
                    .forEach(element => {
                        dispatch(addSelectOptions(element[0], element[1].map(option => ({ label: option[labelName], value: option.id }))))
                    })
            } catch (e) {
                console.error(e)
            }
        }
    }
}

